﻿import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAuth, setRole } from '../Redux/Actions/AuthActions';
import { clearUserSession } from '../Auth/clearAccountClientData.js';
import './styles/LogOut.css';
import PropTypes from "prop-types";

export default function LogOut({ onBeforeLogOut }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogOut = async () => {
        if (onBeforeLogOut) onBeforeLogOut();

        clearUserSession();

        dispatch(setAuth(false));
        dispatch(setRole(null));

        navigate('/login');
    };

    return (
        <button className="header__logout-button-container header__profile-menu-item" onClick={handleLogOut}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 8.75C9.58579 8.75 9.25 9.08579 9.25 9.5C9.25 9.91421 9.58579 10.25 10 10.25V8.75ZM15.8333 10.25C16.2475 10.25 16.5833 9.91421 16.5833 9.5C16.5833 9.08579 16.2475 8.75 15.8333 8.75V10.25ZM13.8637 6.46967C13.5708 6.17678 13.0959 6.17678 12.803 6.46967C12.5101 6.76256 12.5101 7.23744 12.803 7.53033L13.8637 6.46967ZM15.8333 9.5L16.3637 10.0303C16.6566 9.73744 16.6566 9.26256 16.3637 8.96967L15.8333 9.5ZM12.803 11.4697C12.5101 11.7626 12.5101 12.2374 12.803 12.5303C13.0959 12.8232 13.5708 12.8232 13.8637 12.5303L12.803 11.4697ZM10 9.5V10.25H15.8333V9.5V8.75H10V9.5ZM13.3333 7L12.803 7.53033L15.303 10.0303L15.8333 9.5L16.3637 8.96967L13.8637 6.46967L13.3333 7ZM15.8333 9.5L15.303 8.96967L12.803 11.4697L13.3333 12L13.8637 12.5303L16.3637 10.0303L15.8333 9.5Z" fill="#BA4304" fillOpacity="0.6"/>
                <path d="M13 18H7C5.89543 18 5 17.1046 5 16V3C5 1.89543 5.89543 1 7 1H13" stroke="#BA4304" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            Log Out
        </button>
    );
}

LogOut.propTypes = {
    onBeforeLogOut: PropTypes.func,
};